// src/hooks/usePageTracking.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function usePageTracking() {
    const location = useLocation();

    useEffect(() => {
        const page_path = location.pathname + location.search;
        if (typeof window.gtag === "function") {
            window.gtag("event", "page_view", {
                page_path,
                page_location: window.location.href,
                page_title: document.title,
            });
        }
    }, [location]);
}
